import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { HomePage } from './pages/HomePage'
import { AdminPage } from './pages/AdminPage'
import { DownloadPage } from './pages/DownloadPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { Layout } from './components/Layout'

// The player pulls in hls.js (~185 kB gz), which the home page has no use
// for. Splitting it out keeps the first paint small on mobile data - HomePage
// warms the chunk (see utils/prefetch.ts) while the user pastes a link, so by
// the time they tap Play it is already downloaded.
const PlayerPage = lazy(() => import('./pages/PlayerPage'))

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/player"
          element={
            <Suspense fallback={null}>
              <PlayerPage />
            </Suspense>
          }
        />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
